// const GlobalDateFormat = (strDate: string, strTime: string): string | null => {
//   var date = new Date(strDate);

//   // Check if the original date is a valid date
//   if (isNaN(date.getTime())) {
//     date = new Date();
//   }

//   // Extract the existing date components
//   const year = date.getFullYear();
//   const month = (date.getMonth() + 1).toString().padStart(2, "0");
//   const day = date.getDate().toString().padStart(2, "0");

//   // Extract the new time components
//   const [newHours, newMinutes, newSeconds] = strTime.split(":");

//   // Update the time in the original date
//   date.setHours(parseInt(newHours, 10));
//   date.setMinutes(parseInt(newMinutes, 10));
//   date.setSeconds(parseInt(newSeconds, 10));

//   // Format the updated date in the desired format
//   const formattedDate = `${year}-${month}-${day}T${date
//     .getHours()
//     .toString()
//     .padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}:${date
//     .getSeconds()
//     .toString()
//     .padStart(2, "0")}.${date.getMilliseconds().toString().padStart(3, "0")}`;

//   // const originalDate = new Date(originalDateString);

//   // const year = originalDate.getFullYear();
//   // const month = (originalDate.getMonth() + 1).toString().padStart(2, '0');
//   // const day = originalDate.getDate().toString().padStart(2, '0');
//   // const hours = originalDate.getHours().toString().padStart(2, '0');
//   // const minutes = originalDate.getMinutes().toString().padStart(2, '0');
//   // const seconds = originalDate.getSeconds().toString().padStart(2, '0');
//   // const milliseconds = originalDate.getMilliseconds().toString().padStart(3, '0');

//   // const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;

//   // console.log("Original Date:", originalDateString);
//   // console.log("Formatted Date:", formattedDate);
//   return formattedDate;
// };
// export default GlobalDateFormat;

// import toast from "react-hot-toast";

const GlobalDateFormat = (strDate: string, strTime: string): string | null => {
  if (!strDate) {
    return null;
  }
  if (!strTime) {
    return null;
  }
  var date = strDate?.split(/[- : T]/);
  // if (date.length !== 5) {
  //   return null;
  // }
  // Extract the existing date components
  const year = date[0];
  const month = date[1]?.padStart(2, "0");
  const day = date[2]?.padStart(2, "0");

  // Extract the new time components
  const [newHours, newMinutes, newSeconds] = strTime.split(":");

  const formattedDate = `${year}-${month}-${day}T${newHours?.padStart(
    2,
    "0"
  )}:${newMinutes?.padStart(2, "0")}:${newSeconds?.padStart(2, "0")}.000`;

  return formattedDate;
};

export default GlobalDateFormat;
